// Generated from SVG to Code Figma Plugin

export const BaseLineDelete = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.5 6.19434L5.31103 18.2023C5.41739 19.7771 6.72583 21.0002 8.30421 21.0002H15.6958C17.2742 21.0002 18.5826 19.7771 18.689 18.2023L19.5 6.19434"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="M10 11V15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path d="M14 11V15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path d="M2 5.5H22" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path
      d="M7 5.11898L8.08155 3.06733C8.42761 2.41088 9.10869 2 9.85077 2H14.1705C14.9185 2 15.6039 2.41735 15.9473 3.08184L17 5.11898"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
